var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69231 23V11.5V0H14V23H9.69231ZM0 23V0H4.30769V23H0Z",
    fill: "#37A0F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIconBlue);
export default __webpack_public_path__ + "static/media/pause_icon_blue.d80207ad25afcf6c7920cd94df456d20.svg";
export { ForwardRef as ReactComponent };